import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'
import { FormLeadService } from '../../../services/FormLead/FormLeadService'


export interface IFormLeadDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  lead: any
  onDelete: () => void
  leastDestructiveRef: any
}

export function FormLeadDeleteDialog({
  isOpen,
  onClose,
  lead,
  onDelete,
  leastDestructiveRef
}: IFormLeadDeleteDialogProps) {
  const service = new FormLeadService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await service.delete(lead.id)

      toast({
        title: 'Lead deletado',
        description: 'Lead deletado com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onDelete()
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao deletar lead',
        description: 'Erro ao deletar lead, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Deletar lead
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja deletar o lead?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Deletar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
